import { app_route_config_nav } from "prisma-generated/enums";
import type { AppRouteConfigView } from "shared/mappers/database/app-route/app-route-config/app-route-config";
import type { DeviceInfo } from "hub/src/utils/getDeviceInfo";

type IsCurrentPlatformRouteParams = {
  device?: DeviceInfo;
  route?: Partial<AppRouteConfigView>;
};

export const isCurrentPlatformRoute = ({
  device,
  route,
}: IsCurrentPlatformRouteParams): boolean => {
  return !!route?.navType?.includes(
    device?.isNativeApp
      ? app_route_config_nav.app_nav
      : app_route_config_nav.userhub_nav,
  );
};
